// Legacy API client facade - re-exports all legacy API modules for convenient access

import { legacyLoginApi } from "./legacy-login-api";
import { legacyResetPasswordApi } from "./legacy-reset-password-api";

export const legacyApi = {
  login: legacyLoginApi,
  resetPassword: legacyResetPasswordApi,
};
